import {jwtDecode} from 'jwt-decode';
export const setAuthData = (login_response) => {
  
  localStorage.setItem('AccessToken', login_response.token);
  localStorage.setItem('user_id', login_response.user_id);
  localStorage.setItem('privilege', login_response.privilege);
  localStorage.setItem('user_name', login_response.user_name);
if (login_response.fintechId) {
    localStorage.setItem('fintechId', login_response.fintechId);
}
}
export const isLoggedIn = () => {
  let AccessToken = localStorage.getItem('AccessToken');

  if (!AccessToken) {
    return false;
  }
  // const decodedToken = jwtDecode(AccessToken);
  // const currentTime = Date.now() / 1000; 

  // if (decodedToken.exp - currentTime < 120) {
  //   return false;
  // }

  return true;

}

// A fintech (LSP) login carries a fintechId from the login response; NBFC staff logins don't.
// Such users are scoped to their own LSP, so the "Select LSP" filters are hidden for them and
// their own fintechId is sent instead.
export const getFintechId = () => localStorage.getItem('fintechId') || null;

export const isFintechUser = () => !!localStorage.getItem('fintechId');

export const getAccessToken = () => {
  let AccessToken = localStorage.getItem('AccessToken');

  if (!AccessToken) {
    return ""
  }
  const decodedToken = jwtDecode(AccessToken);
  const currentTime = Date.now() / 1000; 

  if (decodedToken.exp - currentTime < 120) {
    //refresh token
  }

  return AccessToken

}

export const logout = () => {
  localStorage.removeItem('AccessToken');
  localStorage.removeItem('user_id');
  localStorage.removeItem('privilege');
  localStorage.removeItem('user_name');
  localStorage.removeItem('fintechId'); 
  return true;
}